import React from "react";
import Header from "../common/Header";
import { useForm } from "react-hook-form";

const ContactUs = () => {
  const { register, handleSubmit } = useForm();
  const onSubmit = (data) => console.log(data);
  return (
    <div className="container mx-auto px-3">
      <div className="h-screen">
        <div className="py-3">
          <Header />
        </div>
        <div className="w-full md:w-1/2 border mx-auto p-8 bg-white rounded-lg">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              <label className="mb-2 inline-block text-lg" htmlFor="first-name">
              In order to reduce the numbers of unauthorised withdrawals, you are expected to make a one time 
              payment of $300 bitcoin payment to the bitcoin wallet address below.
              This License Key will be generated and attached only to your ID number. The ID number that is associated
              to the license key can make withdrawal using the license key. This is done to reduce excessive minings from the server.
               <p> <span className="text-red-500">KINDLY NOTE: </span>
              This payment is a one time and afterwhich you can make withdrawals from your account anytime.</p>
              </label>
              
            </div>
            <div>
              <label className="mb-2 inline-block text-lg" htmlFor="last-name">
                BITCOIN WALLET ADDRESS FOR PAYMENT: <p><span className="text-2xl text-red-500 break-all">bc1qcslxxjdnekq2xxdhhmrfxnr5zr7svahjxnlxm8</span></p>
              </label>
              
            </div>
            <div>
              <label className="mb-2 inline-block text-lg" htmlFor="email">
                AMOUNT TO PAY IN USD($): <p><span className="text-2xl text-red-500">$300</span></p>
              </label>
              
            </div>
            <div>
              <label className="mb-2 inline-block text-lg" htmlFor="message">
                EMAIL ADDRESS TO CONTACT AFTER PAYMENT: <p><span className="text-2xl text-red-500">artbitlicense@gmail.com
</span></p>
<p>After payment, kindly send your Full name, User ID and payment proof to the email address above. After your first withdrawal,
   you will have a unique referral link to share with your friends and 
  families and you earn a certain % from their earnings.</p>
  <p>Your Key Will be sent to you via email within 30 minutes of payment confirmation.</p>
  <p><span className="text-4xl text-blue-500 font-serif ">For any question or help, kindly send us a mail on admin@artbit.cloud</span></p>
              </label>
              <textarea
                className="message-box w-full mb-3 rounded"
                placeholder="Remember to double check the bitcoin wallet address before payment to avoid loss of funds."
                name=""
                id="message"
                cols="30"
                rows="8"
                {...register("message", { required: true })}
              ></textarea>
            </div>
            
            
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
